var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832 1024H192a192 192 0 0 1-192-192v-128h128v128a64 64 0 0 0 64 64h640c35.392 0 64-28.608 64-64V192a64 64 0 0 0-64-64H192C156.672 128 128 156.672 128 192v128H0V192a192 192 0 0 1 192-192h640a192 192 0 0 1 192 192v640a192 192 0 0 1-192 192zM295.488 324.8a64.106667 64.106667 0 0 1 69.76 13.888l128 128c12.48 12.48 18.752 28.864 18.752 45.248s-6.272 32.768-18.752 45.248l-128 128a64.213333 64.213333 0 0 1-69.76 13.888A64.042667 64.042667 0 0 1 256 639.936V576H64a64 64 0 1 1 0-128h192v-64.064c0-25.856 15.616-49.28 39.488-59.136z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.1a591eb8800ddd0287c25f639ddfe8d2.svg";
export { ForwardRef as ReactComponent };